import insightsClient from 'search-insights'

import emitter from 'scripts/utils/emitter'
import { userResourcesApi } from 'scripts/react-components/api'
import { getAlgoliaToken, getInsightsStoredInfo } from 'scripts/react-components/site/AlgoliaEntryKey/utils'

export const sendEventToAlgolia = async () => {
  const algoliaInsightsObjAfterSearch = getInsightsStoredInfo()

  const data = await userResourcesApi.storedGetUserResources()

  if (algoliaInsightsObjAfterSearch && algoliaInsightsObjAfterSearch.queryID) {
    insightsClient('clickedObjectIDsAfterSearch', {
      objectIDs: [algoliaInsightsObjAfterSearch.objectID],
      queryID: algoliaInsightsObjAfterSearch.queryID,
      index: algoliaInsightsObjAfterSearch.indexName,
      eventName: 'clicked_pdp',
      positions: [algoliaInsightsObjAfterSearch.position],
      ...getAlgoliaToken(data)
    })
  }
}

emitter.on('pdp_emitter:algolia-data-layer', () => sendEventToAlgolia())
